'use client';

import { c as _c } from "react/compiler-runtime";
import { useAppExperienceOpeningHoursWeek } from '../_hooks/use-app-experience-purchasable-days';
import { useExperienceFilterContext } from './app-experience-filter-provider';
import { AppExperienceOpeningHours } from './app-experience-opening-hours';
export function AppExperienceOpeningHoursSection() {
  const $ = _c(7);
  const {
    experience,
    ticketCalendar
  } = useExperienceFilterContext();
  const hasOpeningHours = experience.experienceType === "ticket" && !experience.alwaysAvailable;
  const {
    weekDays,
    isLoading
  } = useAppExperienceOpeningHoursWeek(experience, hasOpeningHours);
  if (!hasOpeningHours || isLoading || weekDays.length === 0) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2 className="mb-4 font-heading2">Öffnungszeiten</h2>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== ticketCalendar.today || $[2] !== weekDays) {
    t1 = <AppExperienceOpeningHours days={weekDays} highlightedDate={ticketCalendar.today} />;
    $[1] = ticketCalendar.today;
    $[2] = weekDays;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="mt-4 font-body-small text-secondary-text">Abweichende Öffnungszeiten an Feiertagen etc</p>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <section className="-mx-4 xs:-mx-6 border-b-0 bg-sand px-4 xs:px-6 py-8 sm:mx-0 sm:rounded-3xl sm:px-6" data-experience-opening-hours={true} data-testid="OpeningHours.section">{t0}{t1}{t2}</section>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}